import React, { useEffect, useState } from "react";
import { useLoading } from "../Loading";
import { collection, getDocs, query, where } from "firebase/firestore";
import db, { storage } from "../../firebase/firebaseConfig";
import { useAuth } from "../../contexts/authContext";
import { getDownloadURL, ref } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

function MyPosts() {
    const { setLoading } = useLoading();
    const { currentUser } = useAuth();
    const [lostFoundData, setLostFoundData] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        if (!currentUser) {
            navigate('/');
            return;
        }
        const fetchData = async () => {
            const lostFoundRef = query(collection(db, "LostFound"), where("adopterId", "==", currentUser.uid));
            const lostFoundSnap = await getDocs(lostFoundRef);
            if (lostFoundSnap.empty) {
                setLostFoundData([]);
                setLoading(false);
                return;
            }
            let lostFoundData;
            if (!lostFoundSnap.empty) {
                lostFoundData = lostFoundSnap.docs.map((doc) => ({
                    ...doc.data(),
                    id: doc.id,
                    createdAt: doc.data().createdAt.toDate(), // Store as Date object
                }))
                    .sort((a, b) => {
                        return b.createdAt - a.createdAt; // Sort descending (newest first)
                    })
                    .map((app) => ({
                        ...app,
                        createdAt: format(app.createdAt, 'M/d/yyyy, h:mm:ss a'), // Format for display
                    }));
            }

            const updatedData = await Promise.all(
                lostFoundData.map(async (doc) => {
                    try {
                        if (doc.image) {
                            const imageRef = ref(storage, `LostFound/${doc.image}`);
                            const url = await getDownloadURL(imageRef);
                            setLoading(false);
                            return { ...doc, imageUrl: url };
                        }

                    }
                    catch (error) {
                        console.error(error);
                        setLoading(false);
                        return { ...doc, imageUrl: "" };
                    }
                })
            );
            setLostFoundData(updatedData);
            console.log(updatedData);

        };
        fetchData();
    }, [currentUser]);

    const handleEdit = (id) => {
        navigate(`/edit-post/${id}`, { state: { root: true } });
    };

    return (

        <div className="postContainer">
            <h1>My Post</h1>
            <div className="row">
                {lostFoundData &&
                    lostFoundData.map((doc) => (
                        <div className="rowContainer">
                            <div className="block">
                                <img src={doc.imageUrl} alt="lostFound Pet" />
                                <div>
                                    <h2>{doc.petName}</h2>
                                    <p>{doc.status}</p>
                                    <div style={{display:"flex", justifyContent:"space-between", flexWrap:"wrap"}}>
                                        <p>{doc.createdAt}</p>
                                    <div style={{ display: "flex", justifySelf: "right" }}>
                                        <button onClick={() => handleEdit(doc.id)}>Edit</button>
                                    </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );

}

export default MyPosts;